var getTimeUntil = function getTimeUntil(date) {
  if (!date) return null;
  var targetDate = typeof date === 'string' ? new Date(date) : date;
  var now = new Date();
  var difference = Number(targetDate) - Number(now);

  // If the target date is in the past, return null
  if (difference <= 0) {
    return null;
  }
  var totalMinutes = Math.floor(difference / 60000);
  var days = Math.floor(totalMinutes / 1440);
  var hours = Math.floor(totalMinutes % 1440 / 60);
  var minutes = totalMinutes % 60;
  return {
    days: String(days).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0')
  };
};

export { getTimeUntil as default };
//# sourceMappingURL=index.js.map
